import { useEffect, useState } from "react";
import { API, fmtTgl, pesanGalat, BACKEND } from "../lib/api";
import Shell from "../components/Shell";
import { JudulHalaman, KerangkaBaris, KeadaanGalat } from "../components/kit";
import { Paginasi } from "../components/Paginasi";
import { useAuth } from "../auth";
import { Copy, Trash2, Mail } from "lucide-react";

const PERAN = [["pemilik", "Pemilik Akses"], ["hr", "HR"], ["manajer", "Manajer"]];

export default function RuangKerja() {
  const [info, setInfo] = useState(null);
  const [undangan, setUndangan] = useState([]);
  const [galat, setGalat] = useState(null);
  const [pesan, setPesan] = useState(null);
  const [nama, setNama] = useState("");
  const [u, setU] = useState({ nama: "", email: "", peran: "pemilik" });
  const [kirim, setKirim] = useState(false);
  const [salin, setSalin] = useState(null);
  const [cap, setCap] = useState(Date.now());
  const [riwayat, setRiwayat] = useState(null);
  const [saring, setSaring] = useState({ dari: "", sampai: "", aksi: "" });
  const [jenis, setJenis] = useState([]);
  const [bulan, setBulan] = useState(new Date().toISOString().slice(0, 7));
  const [unduh, setUnduh] = useState(false);
  const [kiriman, setKiriman] = useState(null);
  const [ulang, setUlang] = useState(false);
  const [auditor, setAuditor] = useState("");
  const [kirimAudit, setKirimAudit] = useState(false);
  const [kirimanAudit, setKirimanAudit] = useState(null);
  const { setUser } = useAuth();

  const simpanAuditor = async (e) => {
    e.preventDefault();
    setPesan(null);
    try {
      await API.put("/auditor", { email: auditor });
      setPesan("Email auditor tersimpan.");
      muat();
    } catch (err) { setPesan(pesanGalat(err)); }
  };

  const muatKirimanAudit = async (halaman = 1) => {
    setPesan(null);
    try {
      const r = await API.get("/ekspor/bukti-audit/kiriman", {
        params: { berhalaman: true, halaman, ukuran: 10 },
      });
      setKirimanAudit(r.data);
    }
    catch (err) { setPesan("Riwayat kiriman auditor belum dapat dimuat. Coba lagi sebentar."); }
  };

  const kirimKeAuditor = async () => {
    setKirimAudit(true); setPesan(null);
    try {
      const r = await API.post("/ekspor/bukti-audit/kirim", { bulan });
      setPesan(r.data.pesan);
      muatKirimanAudit();
    } catch (err) { setPesan(pesanGalat(err)); } finally { setKirimAudit(false); }
  };

  const muatRiwayat = async (s = saring, halaman = 1) => {
    setPesan(null);
    try {
      const r = await API.get("/jejak", {
        params: { ...s, berhalaman: true, halaman, ukuran: 25 },
      });
      setRiwayat(r.data);
      if (!jenis.length) API.get("/jejak/jenis").then((x) => setJenis(x.data)).catch(() => {});
    } catch (err) { setPesan(pesanGalat(err)); }
  };

  const ubahSaring = (k, v) => {
    const s = { ...saring, [k]: v };
    setSaring(s);
    if (riwayat) muatRiwayat(s);
  };

  const unduhBukti = async () => {
    setPesan(null); setUnduh(true);
    try {
      const r = await API.get("/ekspor/bukti-audit.pdf", { params: { bulan }, responseType: "blob" });
      const u = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = u; a.download = `bukti_audit_${bulan}.pdf`; a.click();
      URL.revokeObjectURL(u);
    } catch (err) { setPesan(pesanGalat(err)); } finally { setUnduh(false); }
  };

  const muatKiriman = async (halaman = 1) => {
    setPesan(null);
    try {
      const r = await API.get("/ringkasan-mingguan/riwayat", {
        params: { berhalaman: true, halaman, ukuran: 10 },
      });
      setKiriman(r.data);
    }
    catch (err) { setPesan("Riwayat kiriman ringkasan belum dapat dimuat. Coba lagi sebentar."); }
  };

  const kirimUlang = async () => {
    setUlang(true); setPesan(null);
    try {
      const r = await API.post("/ringkasan-mingguan/kirim-ulang");
      setPesan(r.data.pesan);
      muatKiriman();
    } catch (err) { setPesan(pesanGalat(err)); } finally { setUlang(false); }
  };

  const muat = () => {
    setGalat(null);
    API.get("/perusahaan/saya").then((r) => { setInfo(r.data); setNama(r.data.perusahaan?.nama || ""); setAuditor(r.data.perusahaan?.email_auditor || ""); })
      .catch((e) => setGalat(pesanGalat(e)));
    API.get("/undangan").then((r) => setUndangan(r.data)).catch(() => {});
  };
  useEffect(muat, []);

  const kode = info?.perusahaan?.kode;
  const contoh = info?.perusahaan?.id === "perusahaan-contoh";
  const tautanLencana = kode ? `${BACKEND}/api/lencana/${kode}.svg?v=${cap}` : "";
  const potonganKode = kode
    ? `<a href="${window.location.origin}/verifikasi" target="_blank" rel="noreferrer">\n  <img src="${tautanLencana}" alt="Akses diaudit lewat PAM-IT" width="320" height="96" />\n</a>`
    : "";

  const salinKe = async (teks, tanda) => {
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(teks);
      else throw new Error("tanpa clipboard");
      setSalin(tanda);
      setTimeout(() => setSalin(null), 2200);
    } catch {
      setPesan("Browser Anda menolak menyalin otomatis. Sorot teksnya lalu tekan Ctrl+C.");
    }
  };

  const gantiNama = async (e) => {
    e.preventDefault();
    setPesan(null);
    try {
      await API.put("/perusahaan", { nama });
      const me = await API.get("/auth/me");
      setUser(me.data);
      setCap(Date.now());
      setPesan("Nama perusahaan sudah diganti.");
      muat();
    } catch (err) { setPesan(pesanGalat(err)); }
  };

  const ubahFormulir = async (aktif) => {
    setPesan(null);
    try { await API.post("/perusahaan/formulir-publik", { aktif }); muat(); }
    catch (err) { setPesan(pesanGalat(err)); }
  };

  const ubahAktif = async (aktif) => {
    if (!aktif && !window.confirm("Nonaktifkan ruang kerja? Catatan lama tetap bisa dibaca, tapi tidak ada yang bisa ditambah.")) return;
    setPesan(null);
    try { await API.post("/perusahaan/aktif", { aktif }); muat(); }
    catch (err) { setPesan(pesanGalat(err)); }
  };

  const segarkanContoh = async () => {
    if (!window.confirm("Kembalikan data contoh ke keadaan semula? Semua catatan uji di ruang contoh akan dihapus.")) return;
    setPesan(null);
    try {
      const r = await API.post("/demo/segarkan");
      localStorage.setItem("pamit_token", r.data.token);
      const me = await API.get("/auth/me");
      setUser(me.data);
      setPesan(r.data.pesan);
      muat();
    } catch (err) { setPesan(pesanGalat(err)); }
  };

  const undang = async (e) => {
    e.preventDefault();
    setKirim(true); setPesan(null);
    try {
      const r = await API.post("/undangan", u);
      setPesan(r.data.email_terkirim
        ? `Undangan terkirim ke ${r.data.email}.`
        : `Undangan tersimpan, tapi emailnya gagal terkirim. Bagikan tautan ini: ${r.data.tautan}`);
      setU({ nama: "", email: "", peran: "pemilik" });
      muat();
    } catch (err) { setPesan(pesanGalat(err)); } finally { setKirim(false); }
  };

  const cabut = async (id) => {
    setPesan(null);
    try { await API.delete(`/undangan/${id}`); muat(); } catch (err) { setPesan(pesanGalat(err)); }
  };

  const kelasInput = "mt-1.5 w-full border rounded px-3 py-2.5 text-sm";

  return (
    <Shell>
      <JudulHalaman testid="judul-ruang-kerja" judul="Ruang Kerja"
        sub="Atur nama perusahaan, ajak rekan kerja, tempel lencana verifikasi, dan nonaktifkan ruang kerja kalau sudah tidak dipakai." />
      {galat && <KeadaanGalat testid="galat-ruang-kerja" pesan={galat} onCoba={muat} />}
      {!info && !galat && <KerangkaBaris testid="memuat-ruang-kerja" n={4} />}
      {pesan && <p data-testid="pesan-ruang-kerja" className="mb-6 rounded border border-primary/50 bg-primary/10 p-3 text-sm">{pesan}</p>}

      {info && (
        <div className="ruang-kerja-grid grid min-w-0 gap-4 lg:grid-cols-2">
          <section className="panel rounded p-6" data-testid="kotak-identitas">
            <p className="label-kecil">Identitas perusahaan</p>
            <form onSubmit={gantiNama} className="mt-4">
              <label htmlFor="rk-nama" className="label-kecil">Nama perusahaan</label>
              <input id="rk-nama" data-testid="input-nama-perusahaan-baru" value={nama} disabled={contoh}
                onChange={(e) => setNama(e.target.value)} className={`${kelasInput} disabled:opacity-60`} />
              <p className="mt-2 text-xs text-muted-foreground">
                {contoh
                  ? "Ini ruang kerja contoh, jadi namanya dikunci. Daftarkan perusahaan Anda sendiri untuk bisa menggantinya."
                  : <>Kode Anda <span className="font-data">{kode}</span> tidak berubah, jadi surat lama tetap bisa dicek.</>}
              </p>
              {!contoh && (
                <button data-testid="btn-simpan-nama" className="tombol-utama mt-4 px-4 py-2 rounded text-sm">Simpan nama</button>
              )}
              {contoh && (
                <button type="button" data-testid="btn-segarkan-contoh" onClick={segarkanContoh}
                  className="tombol-garis mt-4 px-4 py-2 rounded text-sm">
                  Kembalikan data contoh ke keadaan semula
                </button>
              )}
            </form>
          </section>

          <section className="panel rounded p-6" data-testid="kotak-formulir-umum">
            <p className="label-kecil">Formulir umum</p>
            <p className="mt-4 text-sm">
              {info.formulir_publik
                ? "Terbuka. Siapa pun yang punya tautannya boleh mencatat perubahan akses."
                : "Tertutup. Hanya orang yang sudah masuk yang bisa mencatat perubahan akses."}
            </p>
            <p className="mt-2 text-xs text-muted-foreground">
              Tautan formulir: <span className="font-data break-all">{window.location.origin}/minta/{kode}</span>
            </p>
            <p className="mt-3 text-xs text-muted-foreground">
              Tautan bagikan Bukti Dampak (sudah ada gambar pratayangnya):
            </p>
            <p className="mt-1.5 rounded border bg-muted/40 px-2.5 py-2 text-xs font-data break-words"
              data-testid="tautan-bagikan-bukti">{BACKEND}/api/bagikan/{kode}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button data-testid="btn-ubah-formulir-publik" onClick={() => ubahFormulir(!info.formulir_publik)}
                className="tombol-garis px-4 py-2 rounded text-sm">
                {info.formulir_publik ? "Tutup formulir umum" : "Buka formulir umum"}
              </button>
              <button data-testid="btn-salin-tautan-minta"
                onClick={() => salinKe(`${window.location.origin}/minta/${kode}`, "minta")}
                className="tombol-garis px-4 py-2 rounded text-sm inline-flex items-center gap-2">
                <Copy size={14} /> {salin === "minta" ? "Tersalin" : "Salin tautan"}
              </button>
              <button data-testid="btn-salin-tautan-bagikan"
                onClick={() => salinKe(`${BACKEND}/api/bagikan/${kode}`, "bagikan")}
                className="tombol-garis px-4 py-2 rounded text-sm inline-flex items-center gap-2">
                <Copy size={14} /> {salin === "bagikan" ? "Tersalin" : "Salin tautan bagikan"}
              </button>
            </div>
          </section>

          <section className="panel rounded p-6 lg:col-span-2" data-testid="kotak-undangan">
            <p className="label-kecil">Ajak rekan kerja</p>
            <p className="mt-3 text-sm text-muted-foreground">
              Rekan Anda akan menerima email berisi tautan, lalu membuat kata sandinya sendiri. Kami tidak pernah
              mengirim kata sandi lewat email.
            </p>
            <form onSubmit={undang} className="mt-5 grid gap-4 md:grid-cols-[1fr_1fr_180px_auto] md:items-end">
              <div>
                <label htmlFor="u-nama" className="label-kecil">Nama rekan</label>
                <input id="u-nama" data-testid="input-nama-undangan" required value={u.nama}
                  onChange={(e) => setU({ ...u, nama: e.target.value })} className={kelasInput} />
              </div>
              <div>
                <label htmlFor="u-email" className="label-kecil">Email</label>
                <input id="u-email" data-testid="input-email-undangan" type="email" required value={u.email}
                  onChange={(e) => setU({ ...u, email: e.target.value })} className={kelasInput} />
              </div>
              <div>
                <label htmlFor="u-peran" className="label-kecil">Perannya</label>
                <select id="u-peran" data-testid="pilih-peran-undangan" value={u.peran}
                  onChange={(e) => setU({ ...u, peran: e.target.value })} className={kelasInput}>
                  {PERAN.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                </select>
              </div>
              <button data-testid="btn-kirim-undangan" disabled={kirim}
                className="tombol-utama px-5 py-2.5 rounded text-sm inline-flex items-center gap-2 disabled:opacity-50">
                <Mail size={15} /> {kirim ? "Mengirim…" : "Kirim undangan"}
              </button>
            </form>

            {undangan.length > 0 && (
              <div className="mt-6 divide-y border-t" data-testid="daftar-undangan">
                {undangan.map((x) => (
                  <div key={x.id} data-testid={`undangan-${x.id}`} className="flex flex-wrap items-center gap-x-5 gap-y-1 py-3 text-sm">
                    <span className="font-medium">{x.nama}</span>
                    <span className="font-data text-xs text-muted-foreground">{x.email}</span>
                    <span className="text-xs">{PERAN.find(([k]) => k === x.peran)?.[1] || x.peran}</span>
                    <span className={`text-xs font-medium ${x.dipakai ? "text-primary" : x.kedaluwarsa ? "text-destructive" : "text-accent"}`}>
                      {x.dipakai ? "sudah bergabung" : x.kedaluwarsa ? "kedaluwarsa" : `berlaku sampai ${fmtTgl(x.kedaluwarsa_pada)}`}
                    </span>
                    {!x.dipakai && (
                      <button data-testid={`btn-cabut-${x.id}`} onClick={() => cabut(x.id)}
                        aria-label="Cabut undangan" className="ml-auto tombol-garis p-1.5 rounded">
                        <Trash2 size={14} />
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </section>

          <section className="panel rounded p-6 lg:col-span-2" data-testid="kotak-riwayat">
            <div className="flex flex-wrap items-center gap-3">
              <p className="label-kecil">Riwayat perubahan</p>
              <button data-testid="btn-muat-riwayat" onClick={() => muatRiwayat()}
                className="tombol-garis px-3 py-1.5 rounded text-xs">
                {riwayat ? "Segarkan" : "Tampilkan riwayat"}
              </button>
            </div>
            <p className="mt-3 text-sm text-muted-foreground">
              Siapa mengubah apa dan kapan. Waktunya diambil dari server, jadi tidak bisa diatur belakangan.
            </p>
            {riwayat && (
              <div className="mt-5 grid gap-3 md:grid-cols-[160px_160px_1fr_auto] md:items-end">
                <div>
                  <label htmlFor="rw-dari" className="label-kecil">Dari tanggal</label>
                  <input id="rw-dari" type="date" data-testid="saring-dari" value={saring.dari}
                    onChange={(e) => ubahSaring("dari", e.target.value)} className={kelasInput} />
                </div>
                <div>
                  <label htmlFor="rw-sampai" className="label-kecil">Sampai tanggal</label>
                  <input id="rw-sampai" type="date" data-testid="saring-sampai" value={saring.sampai}
                    onChange={(e) => ubahSaring("sampai", e.target.value)} className={kelasInput} />
                </div>
                <div>
                  <label htmlFor="rw-aksi" className="label-kecil">Jenis aksi</label>
                  <select id="rw-aksi" data-testid="saring-aksi" value={saring.aksi}
                    onChange={(e) => ubahSaring("aksi", e.target.value)} className={kelasInput}>
                    <option value="">Semua jenis aksi</option>
                    {jenis.map((j) => <option key={j} value={j}>{j}</option>)}
                  </select>
                </div>
                <button type="button" data-testid="btn-bersihkan-saring"
                  onClick={() => { const s = { dari: "", sampai: "", aksi: "" }; setSaring(s); muatRiwayat(s); }}
                  className="tombol-garis px-3 py-2.5 rounded text-xs">Bersihkan penyaring</button>
              </div>
            )}
            {riwayat && (
              <p className="mt-4 text-xs text-muted-foreground" data-testid="jumlah-riwayat">
                {riwayat.total} catatan tersedia. Menampilkan {riwayat.items.length} catatan di halaman ini.
              </p>
            )}
            {riwayat && (
              riwayat.items.length === 0
                ? <p className="mt-4 text-sm text-muted-foreground">Belum ada catatan perubahan.</p>
                : (
                  <div className="mt-5 overflow-x-auto">
                    <table className="w-full text-sm border-collapse" data-testid="tabel-riwayat">
                      <thead>
                        <tr className="bg-muted/60">
                          {["Waktu", "Siapa", "Apa", "Keterangan"].map((h) => (
                            <th key={h} className="text-left p-2.5 label-kecil font-normal">{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {riwayat.items.map((j) => (
                          <tr key={j.id} data-testid={`riwayat-${j.id}`} className="border-t">
                            <td className="p-2.5 tabular whitespace-nowrap">{fmtTgl(j.waktu)}</td>
                            <td className="p-2.5">{j.aktor}</td>
                            <td className="p-2.5 font-data text-xs">{j.aksi}</td>
                            <td className="p-2.5 text-muted-foreground">{j.ringkasan}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )
            )}
            <Paginasi
              data={riwayat}
              onHalaman={(halaman) => muatRiwayat(saring, halaman)}
              testid="riwayat"
            />
          </section>

          <section className="panel rounded p-6" data-testid="kotak-ekspor-audit">
            <p className="label-kecil">Ekspor bukti audit</p>
            <p className="mt-3 text-sm text-muted-foreground">
              Satu berkas PDF berisi bukti kontrol sebulan: ringkasan angka, rincian pembukaan dan penutupan akses,
              surat yang terbit, akses yang masih terbuka, serta jejak perubahan data. Siap diserahkan ke auditor.
            </p>
            <div className="mt-5 flex flex-wrap items-end gap-3">
              <div>
                <label htmlFor="ea-bulan" className="label-kecil">Periode</label>
                <input id="ea-bulan" type="month" data-testid="pilih-bulan-audit" value={bulan}
                  onChange={(e) => setBulan(e.target.value)} className={kelasInput} />
              </div>
              <button type="button" data-testid="btn-unduh-bukti-audit" onClick={unduhBukti} disabled={unduh || !bulan}
                className="tombol-utama px-4 py-2.5 rounded text-sm disabled:opacity-50">
                {unduh ? "Menyiapkan…" : "Unduh bukti audit (PDF)"}
              </button>
              <button type="button" data-testid="btn-kirim-bukti-audit" onClick={kirimKeAuditor}
                disabled={kirimAudit || !bulan || !info.perusahaan?.email_auditor}
                className="tombol-garis px-4 py-2.5 rounded text-sm disabled:opacity-50">
                {kirimAudit ? "Mengirim…" : "Kirim ke auditor"}
              </button>
            </div>
            <form onSubmit={simpanAuditor} className="mt-5 flex flex-wrap items-end gap-3 border-t pt-5">
              <div className="min-w-[240px] flex-1">
                <label htmlFor="ea-auditor" className="label-kecil">Email auditor</label>
                <input id="ea-auditor" type="email" required data-testid="input-email-auditor" value={auditor}
                  onChange={(e) => setAuditor(e.target.value)} placeholder="auditor@kantorakuntan.co.id"
                  className={kelasInput} />
              </div>
              <button data-testid="btn-simpan-auditor" className="tombol-garis px-4 py-2.5 rounded text-sm">
                Simpan email auditor
              </button>
              <button type="button" data-testid="btn-muat-kiriman-audit" onClick={() => muatKirimanAudit()}
                className="tombol-garis px-4 py-2.5 rounded text-xs">
                {kirimanAudit ? "Segarkan riwayat kirim" : "Riwayat kirim ke auditor"}
              </button>
            </form>
            <p className="mt-3 text-xs text-muted-foreground">
              Auditor menerima email berisi tautan unduh yang berlaku 14 hari, jadi berkasnya tidak nyangkut
              di lampiran email. Setiap kali auditor membukanya, itu ikut tercatat di riwayat.
            </p>
            {kirimanAudit && (
              kirimanAudit.items.length === 0
                ? <p className="mt-4 text-sm text-muted-foreground" data-testid="kiriman-audit-kosong">Belum ada bukti audit yang dikirim.</p>
                : (
                  <div className="mt-4 divide-y border-t" data-testid="daftar-kiriman-audit">
                    {kirimanAudit.items.map((k) => (
                      <div key={k.id} data-testid={`kiriman-audit-${k.id}`} className="flex flex-wrap items-center gap-x-4 gap-y-1 py-3 text-sm">
                        <span className="font-data text-xs">{k.bulan}</span>
                        <span className="text-xs">{k.email_tujuan}</span>
                        <span className="tabular whitespace-nowrap text-xs">{fmtTgl(k.dibuat_pada)}</span>
                        <span className={`text-xs font-medium ${k.jumlah_dibuka > 0 ? "text-primary" : "text-muted-foreground"}`}>
                          {k.jumlah_dibuka > 0 ? `dibuka ${k.jumlah_dibuka}x` : "belum dibuka"}
                        </span>
                      </div>
                    ))}
                  </div>
                )
            )}
            <Paginasi
              data={kirimanAudit}
              onHalaman={muatKirimanAudit}
              testid="kiriman-audit"
            />
          </section>

          <section className="panel rounded p-6" data-testid="kotak-kiriman-ringkasan">
            <div className="flex flex-wrap items-center gap-3">
              <p className="label-kecil">Ringkasan Senin pagi</p>
              <button data-testid="btn-muat-kiriman" onClick={() => muatKiriman()}
                className="tombol-garis px-3 py-1.5 rounded text-xs">
                {kiriman ? "Segarkan" : "Tampilkan riwayat kirim"}
              </button>
              <button data-testid="btn-kirim-ulang-ringkasan" onClick={kirimUlang} disabled={ulang}
                className="tombol-garis px-3 py-1.5 rounded text-xs disabled:opacity-50">
                {ulang ? "Mengirim…" : "Kirim ulang sekarang"}
              </button>
            </div>
            <p className="mt-3 text-sm text-muted-foreground">
              Email ringkasan dikirim otomatis tiap Senin pagi ke semua Admin IT. Kalau gagal, kami coba lagi sekali
              secara otomatis; kalau tetap gagal, kirim ulang dari sini.
            </p>
            {kiriman && (
              kiriman.items.length === 0
                ? <p className="mt-4 text-sm text-muted-foreground" data-testid="kiriman-kosong">Belum ada pengiriman tercatat.</p>
                : (
                  <div className="mt-5 divide-y border-t" data-testid="daftar-kiriman">
                    {kiriman.items.map((k) => (
                      <div key={k.id} data-testid={`kiriman-${k.id}`} className="flex flex-wrap items-center gap-x-4 gap-y-1 py-3 text-sm">
                        <span className="tabular whitespace-nowrap">{fmtTgl(k.waktu)}</span>
                        <span className="text-xs">{k.pemicu === "manual" ? "kirim ulang manual" : "otomatis Senin"}</span>
                        <span className="font-data text-xs">{k.terkirim}/{k.penerima} terkirim</span>
                        <span className={`text-xs font-medium ${k.status === "berhasil" ? "text-primary" : k.status === "gagal" ? "text-destructive" : "text-accent"}`}>
                          {k.status}
                        </span>
                        {k.gagal > 0 && (
                          <span className="text-xs text-muted-foreground">{k.rincian_gagal?.[0]?.alasan}</span>
                        )}
                      </div>
                    ))}
                  </div>
                )
            )}
            <Paginasi
              data={kiriman}
              onHalaman={muatKiriman}
              testid="kiriman-ringkasan"
            />
          </section>

          <section className="panel rounded p-6" data-testid="kotak-lencana">
            <p className="label-kecil">Lencana verifikasi</p>
            <p className="mt-3 text-sm text-muted-foreground">
              Tempel lencana ini di situs perusahaan Anda. Angkanya ikut segar sendiri karena diambil langsung dari catatan.
            </p>
            <img src={tautanLencana} alt="Lencana PAM-IT" width="320" height="96" className="mt-5 rounded" data-testid="pratayang-lencana" />
            <textarea readOnly value={potonganKode} rows={4} data-testid="kode-lencana"
              className="mt-4 w-full border rounded px-3 py-2.5 text-xs font-data" />
            <button data-testid="btn-salin-lencana" onClick={() => salinKe(potonganKode, "lencana")}
              className="tombol-garis mt-3 px-4 py-2 rounded text-sm inline-flex items-center gap-2">
              <Copy size={14} /> {salin === "lencana" ? "Tersalin" : "Salin kodenya"}
            </button>
          </section>

          <section className="panel rounded p-6" data-testid="kotak-nonaktif">
            <p className="label-kecil">Nonaktifkan ruang kerja</p>
            <p className="mt-3 text-sm text-muted-foreground">
              {info.aktif
                ? "Kalau perusahaan sudah tidak memakai PAM-IT, nonaktifkan saja. Catatan lama tetap bisa dibaca dan surat lama tetap sah, tapi tidak ada yang bisa ditambah lagi."
                : "Ruang kerja ini sedang nonaktif. Tidak ada catatan baru yang bisa masuk sampai Anda aktifkan lagi."}
            </p>
            <p className="mt-4 font-data text-sm">
              {info.jumlah_rekan} rekan · {info.jumlah_undangan} undangan menunggu · {info.jumlah_surat} surat terbit
            </p>
            {contoh ? (
              <p className="mt-4 text-xs text-muted-foreground">
                Ruang kerja contoh tidak bisa dinonaktifkan supaya pengunjung selalu punya contoh untuk dilihat.
              </p>
            ) : (
              <button data-testid="btn-ubah-aktif" onClick={() => ubahAktif(!info.aktif)}
                className={`mt-4 px-4 py-2 rounded text-sm ${info.aktif ? "tombol-garis" : "tombol-utama"}`}>
                {info.aktif ? "Nonaktifkan ruang kerja" : "Aktifkan kembali"}
              </button>
            )}
          </section>
        </div>
      )}
    </Shell>
  );
}
